import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import Link from '@src/components/link';
import AppointmentSuccessModalStore from './store';
import CloseBtn from '@src/business-components/close-btn';

import getPageLocalesData from '@src/global-locales/get-page-locales-data';
const pageLocalesData = getPageLocalesData();

const styles = require('./index.less');

/**
 * 弹窗模板, 可以快速套用修改
 */
const AppointmentSuccessModal = ({ store, onClose }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }
  const renderList = () => {
    return store.itemList.map((item, key) => {
      return (
        <div
          className={styles.listItem}
          key={key}
          onClick={() => {
            store.onRedirectLink(item.link);
            // item.onClick();
          }}
        >
          <div className={cx(styles.itemImg, styles['itemImg' + key])}>{/* {} */}</div>
          {/* <div className={styles.itemName}>{item.name}</div> */}
        </div>
      );
    });
  };

  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={cx(styles.modalBOx)}>
        {/* <Link className={styles.closeBtn} onClick={store.onClickClose} /> */}
        <div className={styles.closeBox}>
          <CloseBtn onClose={store.onClickClose} />
        </div>
        <div className={styles.bg} />
        <div className={styles.content}>
          <div className={styles.title}>
            {store.email} {pageLocalesData.reserve.success.title}
          </div>
          <div className={styles.tips}>[ {pageLocalesData.reserve.success.tips} ]</div>
          <div className={styles.listBox}>{renderList()}</div>
        </div>
        <Link className={styles.btnConfirm} onClick={store.onClickClose}>
          {pageLocalesData.reserve.success.btnConfirm}
        </Link>
      </div>
    </ModalContainer>
  );
};

export default wrapStore(AppointmentSuccessModal, AppointmentSuccessModalStore);
